import ConfirmForm from './ConfirmForm'

export default ConfirmForm



// WEBPACK FOOTER //
// ./src/views/ResetConfirm/components/ConfirmForm/index.js